function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var GlobalSMS = function GlobalSMS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color || "#222222",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16.37c-2.23 0-2.83-4.88-2.83-7.76S13.77.85 16 .85s2.83 4.88 2.83 7.76-.6 7.76-2.83 7.76m-.03-14.02c-.33.15-1.3 2.24-1.3 6.26s.92 6.01 1.33 6.25c.41-.24 1.33-2.33 1.33-6.25s-.97-6.11-1.36-6.26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 16.37c-4.28 0-7.76-3.48-7.76-7.76S11.72.85 16 .85s7.76 3.48 7.76 7.76-3.48 7.76-7.76 7.76m0-14.02a6.27 6.27 0 0 0-5.617 3.5h11.234A6.27 6.27 0 0 0 16 2.35M9.74 8.61q.001-.648.128-1.26h12.264a6.3 6.3 0 0 1 .005 2.5H9.864a6.3 6.3 0 0 1-.124-1.24M16 14.87a6.27 6.27 0 0 1-5.627-3.52h11.254A6.27 6.27 0 0 1 16 14.87M1.27 22.99c.24.11.48.16.73.16v.01c.42 0 .82-.15 1.15-.44l2.06-1.8c.04-.04.1-.06.16-.06h10.62c.96 0 1.75-.79 1.75-1.75v-.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.5c0 .14-.11.25-.25.25H5.37c-.42 0-.83.15-1.15.43l-2.06 1.8c-.11.09-.22.06-.27.04-.06-.03-.15-.09-.15-.23V8.6c0-.14.11-.25.25-.25h4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4c-.96 0-1.75.79-1.75 1.75v12.8c0 .69.4 1.3 1.03 1.59",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
export default GlobalSMS;
GlobalSMS.displayName = 'GlobalSMS';